<template>
    <button class="data-report-btn">
        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M4.86526 12.6895H4.82384L4.79455 12.7188L1.94211 15.5712V3.52632C1.94211 3.10616 2.10901 2.70321 2.40611 2.40611C2.70321 2.10901 3.10616 1.94211 3.52632 1.94211H14.4737C14.8938 1.94211 15.2968 2.10901 15.5939 2.40611C15.891 2.70321 16.0579 3.10616 16.0579 3.52632V11.1053C16.0579 11.5254 15.891 11.9284 15.5939 12.2255C15.2968 12.5226 14.8938 12.6895 14.4737 12.6895H4.86526ZM1.84211 17.1H1.88353L1.91282 17.0707L5.25195 13.7316H14.4737C15.1702 13.7316 15.8382 13.4549 16.3308 12.9623C16.8233 12.4698 17.1 11.8018 17.1 11.1053V3.52632C17.1 2.82977 16.8233 2.16176 16.3308 1.66923C15.8382 1.1767 15.1702 0.9 14.4737 0.9H3.52632C2.82977 0.9 2.16176 1.1767 1.66923 1.66923C1.1767 2.16176 0.9 2.82977 0.9 3.52632V17V17.1H1H1.84211Z" fill="currentColor" stroke="currentColor" stroke-width="0.2"/>
        </svg>
        <span class="data-report-text">
            {{ questionText }} <span class="write-us-text">{{ callToActionText }}</span>
        </span>
    </button>
</template>

<script lang="ts">
import { Vue, Component, Prop } from "vue-property-decorator";

@Component({
    name: 'ReportButton',
})
export default class ReportButton extends Vue {
    @Prop()
    public questionText!: string;

    @Prop()
    public callToActionText!: string;
}
</script>

<style lang="scss" scoped>
.data-report-btn {
    max-width: 320px;
    width: 100%;
    min-height: 48px;
    padding: 0.75rem 1.25rem;
    background: rgba(255, 255, 255, 0.9);
    backdrop-filter: blur(15px);
    border: 1.5px solid rgba(102, 123, 242, 0.2);
    border-radius: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.5rem;
    cursor: pointer;
    transition: all 0.3s ease;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
    font-family: 'Inter', -apple-system, BlinkMacSystemFont, sans-serif;
    color: #667bf2;
    margin-left: auto;
    margin-top: 0.75rem;
}

.data-report-btn:hover {
    background: rgba(102, 123, 242, 0.05);
    border-color: rgba(102, 123, 242, 0.35);
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(102, 123, 242, 0.12);
}

.data-report-btn:active {
    transform: translateY(0);
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
}

.data-report-btn:focus {
    outline: none;
    border-color: #667bf2;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04), 0 0 0 3px rgba(102, 123, 242, 0.15);
}

.data-report-btn svg {
    flex-shrink: 0;
    transition: all 0.3s ease;
}

.data-report-btn:hover svg {
    transform: scale(1.05);
}

.data-report-text {
    font-size: 13px;
    font-weight: 500;
    color: #475569;
    line-height: 1.4;
    text-align: left;
}

.write-us-text {
    color: #2f45a5;
    font-weight: 600;
    transition: color 0.3s ease;
}

.data-report-btn:hover .write-us-text {
    color: #667bf2;
}

/* Responsive adjustments */
@media only screen and (max-width: 599px) {
    .data-report-btn {
        max-width: 100%;
    }
}

@media only screen and (min-width: 600px) {
    .data-report-btn {
        max-width: 320px;
    }
}
</style>